<template>
  <div>
    <div class="blog_topic_sm row row-cols-lg-4 row-cols-md-2 g-1">
      <!-- 排序 -->
      <div class="sel_array">
        <div class="">
          <el-switch
            v-model="swt"
            :active-text="$t('blog.cardList.new')"
            :inactive-text="$t('blog.cardList.Topbrowse')"
          >
          </el-switch>
        </div>
      </div>
      <!-- /.END 排序 -->
      <div
        class="sm_width"
        v-for="(item, ix) in list"
        @click="
          $router.push({
            name: 'blogDetail',
            query: {
              id: item.id,
            },
          })
        "
      >
        <div class="o_topic_post">
          <div class="o_toppart">
            <span
              class="o_topimg_icon"
              @click.stop="
                $router.push({
                  name: 'blogUserInfo',
                  query: { id: item.sgL_UsersId },
                })
              "
              ><img :src="item.sgL_UsersBLog" /><span class="txt">{{
                item.sgL_BlogName
              }}</span></span
            >
            <img :src="item.sgL_UploadTempUrl" class="topic_img" />
            <div class="o_topic_title">
              {{ item.sgL_Title }}
            </div>
          </div>
          <div class="o_botpart">
            <p class="user_icon">
              <img :src="item.userLogoSmail" />
            </p>
            <p class="user_info">
              <span class="txt">{{ item.sgL_UsersName }}</span>
              <span class="postime">{{ item.sgL_CreateTimeE }}</span>
            </p>
            <p class="blog_desciption">
              <span>{{
                item.sgL_Content.replace(/<\/?.+?>/g, "").replace(/ /g, "")
              }}</span>
            </p>
            <p class="blog_count">
              <span class="view"
                ><i class="fas fa-eye">{{ item.sgL_ViewCount }}</i></span
              >
              <span class="like"
                ><i class="fas fa-thumbs-up">{{ item.sgL_LikeCount }}</i></span
              >
              <span class="share"
                ><i class="fas fa-share">{{ item.sgL_SharCount }}</i></span
              >
            </p>
          </div>
        </div>
      </div>
      <div class="row my-5" style="width: 100%; justify-content: center">
        <pagination
          :currentPage="pageParams.currentPage"
          :total="pageParams.total"
          :limit="pageParams.limit"
          :small="true"
          :pageSizes="pageParams.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/common/Page";
export default {
  components: { pagination },
  props: ["sgL_NotInId"],
  data() {
    return {
      list: [],
      swt: false,
      pageParams: {
        currentPage: 1,
        limit: 8,
        total: 0,
        pageshow: false,
        pageSizes: [8, 16, 24, 32],
      },
    };
  },
  created() {
    this.getData();
  },
  watch: {
    swt() {
      this.getData();
    },
  },
  methods: {
    getData() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        sgL_NotInId: this.sgL_NotInId,
        sgL_IsShow: true,
      };
      if (this.$route.query && this.$route.query.categoryId) {
        params.sgL_NewTypeId = this.$route.query.categoryId;
      } else {
        params.selectAll = true;
      }
      if (this.swt) {
        params.sorting = "";
      } else {
        params.sorting = "QueriesCount";
      }
      this.$api.blog.GetAll(params).then((res) => {
        this.list = res.data.result.items;
        this.pageParams.total = res.data.result.totalCount;
      });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getData();
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blog/cardList.vue